import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Entity, Link } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ContentEntityRichSubtitle, ContentEntityRichTitle, LinkEntityButton, useLang } from '@shapeable/ui';
import { LIGHT_BROWN, VILLARS_TURQUOISE } from '../../theme';

const cls = classNames('banner-tltles');

// -------- Types -------->

// -------- Props -------->

export type BannerTitlesProps = Classable & HasChildren & { 
  entity?: Entity;
};

export const BannerTitlesDefaultProps: Omit<BannerTitlesProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    margin-bottom: ${theme.UNIT(15)};
  `,
  desktop: css`
    margin-bottom: 0;
  `,
});

const TitleStyles = breakpoints({
  base: css`
    font-size: 3em;
    font-weight: 600;
    line-height: 1.15em;
    letter-spacing: -0.06ch;
    margin-top: ${theme.UNIT(6)};
    margin-bottom: ${theme.UNIT(6)};
    font-family: ${theme.FONT('sans')};
    color: ${theme.COLOR('strong')};

    strong, b {
      font-weight: 500;
      color: inherit;
    }
  `,
  tablet: css`
    font-size: 4em;
  `,
  desktop: css`
    font-size: 5em;
  `,

});


const SubtitleStyles = breakpoints({
  base: css`
    font-size: 1.1em;
    color: ${theme.COLOR('strong')};
    margin-bottom: ${theme.UNIT(6)};
  `,
  tablet: css`
    font-size: 1.2em;
  `,
  desktop: css`
    font-size: 1.4em;
  `,
});

const ApplyNowLinkStyles = breakpoints({
  base: css`
    max-width: 300px;
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Title: styled(ContentEntityRichTitle).attrs(cls.attr('title'))`${TitleStyles}`,
    Subtitle: styled(ContentEntityRichSubtitle).attrs(cls.attr('subtitle'))`${SubtitleStyles}`,
    LinkButton: styled(LinkEntityButton)`${ApplyNowLinkStyles}`,
};

export const BannerTitles: Shapeable.FC<BannerTitlesProps> = (props) => {
  const { className, children, entity } = props;

  const { bannerLinks = [] } = entity || {};

  const firstBannerLink = bannerLinks[0] || {};
  const bannerLinkLabel = firstBannerLink?.label || 'Apply to Join Us';

  const t = useLang();
  
  return (
    <My.Container className={cls.name(className)}>
      <My.Title entity={entity} />
      <My.Subtitle entity={entity} />
      <My.LinkButton entity={firstBannerLink}>{t(bannerLinkLabel)}</My.LinkButton>
    {children}
    </My.Container>
  )
};

BannerTitles.cls = cls;